module.exports = __webpack_public_path__ + "img/ch15_08_装笨教学.ac666082.jpg";